var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgRadioButtonOff = function SvgRadioButtonOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "radio-button-off_svg__a",
    d: "M9 1.212a7.785 7.785 0 11-5.508 2.28A7.737 7.737 0 019 1.212M9 0a9 9 0 109 9 9 9 0 00-9-9z"
  })));
};

export default SvgRadioButtonOff;